import trackingData from '../assets/fact_2go_tracking.json';
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://9or1cb84ae.execute-api.ap-southeast-1.amazonaws.com/prod-backup';

export const getTrackingHistory = async (trackingNumber) => {
  try {
    const encodedTrackingNumber = encodeURIComponent(trackingNumber);
    const response = await fetch(`${API_BASE_URL}/tracking/${encodedTrackingNumber}`);

    if (!response.ok) {
      if (response.status === 404) {
        throw new Error('Tracking number not found');
      }
      throw new Error('Failed to fetch tracking information');
    }

    const data = await response.json();
    console.log('API Response:', data);
    return data;
  } catch (error) {
    console.error('Error fetching tracking history:', error);
    throw error;
  }
};

// Mock data using JSON file
export const getMockTrackingHistory = (trackingNumber) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const trackingEvents = trackingData.filter(item => item.tracking_no === trackingNumber);

      if (trackingEvents.length === 0) {
        reject(new Error('Tracking number not found'));
        return;
      }

      // Sort by timestamp and map to expected format
      const sortedEvents = trackingEvents
        .sort((a, b) => new Date(a.timestamp_2go) - new Date(b.timestamp_2go))
        .map(item => ({
          trackingNumber: item.tracking_no,
          status: item.status_2go,
          timestamp: item.timestamp_2go
        }));

      resolve(sortedEvents);
    }, 1000);
  });
};